// src/components/settings/SettingsLayout.jsx
import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import Sidebar from "./Sidebar";



export default function SettingsLayout({
  activeTab,
  setActiveTab,
  children,
}) {
  return (
    <Container fluid className="p-3 bg-light min-vh-100">
      <Row>
        <Col xl={3} lg={4} md={12}>
          <Sidebar
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          />
        </Col>

        <Col xl={9} lg={8} md={12}>
          <Card className="main-card">
            <Card.Body>{children}</Card.Body>
          </Card>
        </Col>
      </Row>
        <style>
        {
          `
          /* src/styles/settings.css */

.sidebar-item {
  padding: 10px;
  cursor: pointer;
  border-radius: 6px;
  font-size: 14px;
}

.sidebar-item.active {
  background: #ffe9e0;
  color: #ff6a2f;
}

.section-border {
  border-bottom: 1px solid #eee;
  margin-bottom: 20px;
  padding-bottom: 15px;
}

.upload-box {
  display: flex;
  gap: 15px;
  background: #f8f9fa;
  padding: 15px;
  border-radius: 8px;
}

.upload-preview {
  width: 70px;
  height: 70px;
  border: 1px dashed #ccc;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-orange {
  background: #ff6a2f;
  border: none;
}`
        }
      </style>
    </Container>
  );
}